export const AuthLocalStorageKeys = {
    activeStudySite: 'activeStudySite',
};

export enum AUTH_STAGE {
    NEW_PASS_REQUIRED = 'NEW_PASS_REQUIRED',
    MFA_REQUIRED = 'MFA_REQUIRED',
    TOTP_REQUIRED = 'TOTP_REQUIRED',
    CUSTOM_CHALLENGE = 'CUSTOM_CHALLENGE',
    MFA_SETUP = 'MFA_SETUP',
    SELECT_MFA_TYPE = 'SELECT_MFA_TYPE',
}

export enum CognitoAuthErrorCode {
    NETWORK_ERROR = 'NetworkError',
    INTERNAL_ERROR = 'InternalErrorException',
    INVALID_LAMBDA = 'InvalidLambdaException',
    INVALID_PARAMETER = 'InvalidParameterException',
    INVALID_USER_POOL_CONFIGURATION = 'InvalidUserPoolConfigurationException',
    NOT_AUTHORIZED = 'NotAuthorizedException',
    PASSWORD_RESET_REQUIRED = 'PasswordResetRequiredException',
    RESOURCE_NOT_FOUND = 'ResourceNotFoundException',
    TOO_MANY_REQUESTS = 'TooManyRequestsException',
    UNEXPECTED_LAMBDA = 'UnexpectedLambdaException',
    USER_LAMBDA_VALIDATION = 'UserLambdaValidationException',
    USER_NOT_CONFIRMED = 'UserNotConfirmedException',
    USER_NOT_FOUND = 'UserNotFoundException',
    PASSWORD_UNAVAILABLE = 'PasswordUnavailable',
}
